import { BASE_STORE_URL } from '@/request/config';
import request from '@/request/tsRequest';
import { supportedAdapterIdMap } from '@/utils/configs/adapterIds.configs';
import type { IAccessoriesResponse } from '@/pages/relatedAccessories/typings';
import { CATEGORY_KEY } from '@/pages/relatedAccessories/constants';

/** 获取搜索推荐词条 */
export function getProductIdsByAdapterIds(adapterIds: number[]) {
  return request<Record<number, number[]>>({
    url: BASE_STORE_URL + '/product/getAdapterType',
    method: 'POST',
    data: adapterIds,
  });
}

/** 获取x3x4的配件商品id */
export async function getX3X4AccessoriesProductIds() {
  // x3x4
  const adapterIds = Object.entries(supportedAdapterIdMap).map(([, item]) => {
    return item.adapterId;
  });

  try {
    const res = await getProductIdsByAdapterIds(adapterIds);

    const x3Accessories = res[supportedAdapterIdMap[19].adapterId] || [];

    const x4Accessories = res[supportedAdapterIdMap[26].adapterId] || [];
    // 排平
    // const productIds = Object.entries(res).reduce<number[]>((prev, item) => {
    //   return prev.concat(item[1]);
    // }, []);

    // 去重
    // const deduplicationProductIds = [...new Set(productIds)].sort((a, b) => b - a);

    return {
      // all: deduplicationProductIds,
      x3Accessories,
      x4Accessories,
    };
  } catch (err) {
    console.error(err);
    return {};
  }
}

/** 根据adapterTypeId获取配件 */
export async function getX3X4Accessories(adapterTypeId: number) {
  return await request<IAccessoriesResponse>({
    url: BASE_STORE_URL + '/meta/cp/listAccessory',
    params: {
      adapterTypeId,
      categoryKey: CATEGORY_KEY,
    },
  });
}
